import React , {useEffect} from 'react';
import './Home.css';
import Footer from '../components/Footer';
import NavbarHome from '../components/HomeComponents/NavbarHome';
import HeroArea from '../components/HomeComponents/HeroArea';
import ExperincesSection from '../components/ExperincesSection';
import MostPlacesSection from '../components/MostPlacesSection';
import MapSection from '../components/MapSection';
import HeroAreaExplore from '../components/HeroAreaExplore';
import SideFooter from '../components/SideFooter';
import HeroPackages from '../components/HeroPackages';
import Aos from 'aos';
import "aos/dist/aos.css";
import HeroSearch from '../components/HeroSearch';
import { Link } from 'react-router-dom';



const Home = () => {

  useEffect(() => {
    Aos.init( {  duration: 1200 } )
  } , []);

  
  const openInNewTab = url => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };


  return (
    <div className="main_homepage" >

    
    <NavbarHome />

    {/* <HeroArea /> */}

    <HeroPackages />


    <div className="section expereinces_section container-mid">

<div className="d-flex-c f-sp top_area_headlines ">

  <div className="d-flex-c"  data-aos="fade-right" data-aos-delay="30" data-aos-easing="ease" data-aos-mirror="true" >

<div className="info_box"></div>
<h1 className="main_headline"   >   تجارب يمديك تجربها ؟ </h1>
</div>

    <Link to="/all-experinces" id="all-experinces" >
    <button className="btn_category bg_green" data-aos="fade-left" data-aos-delay="50" data-aos-easing="ease-in" data-aos-mirror="true" > عرض الكل </button>
    </Link>


</div>

<ExperincesSection />

</div>

    <div className="section expereinces_section ">

  <div className="d-flex-c container-mid mb-2" data-aos="fade-right" data-aos-delay="30" data-aos-easing="ease" data-aos-mirror="true" >

<div className="info_box"></div>
<h1 className="main_headline" >   اكتشف معنا عالم جديد </h1>
</div>





<HeroAreaExplore />

</div>

<div className="section embed_map_section">


<div className="container-mid map_div">
  
<div className="d-flex-c"  >

<div className="info_box"></div>
<h1 className="main_headline color-white">    أكتشف أهم الوجهات </h1>
</div>

</div>
<MapSection />



</div>

<div className="section most_places_section container-mid">

<div className="d-flex-c f-sp top_area_headlines">

  <div className="d-flex-c" data-aos="fade-right" data-aos-delay="30" data-aos-easing="ease" data-aos-mirror="true" >

<div className="info_box"></div>
<h1 className="main_headline">   ابرز الاماكن </h1>
</div>

    <Link to="/all-places" id="all-places" >
    <button className="btn_category bg_green"> عرض الكل </button>
    </Link>


</div>

<MostPlacesSection />

</div>

    <HeroSearch />

    <SideFooter />
    

    <Footer />

    </div>
  )
}

export default Home